import {ChangeEvent} from "react";
import rootStores from "@/Stores/RootStores";
import {FavoriteProduct} from "../model/types";

export const useFavorite = (product: FavoriteProduct) => {
    const {favouritesStore} = rootStores;

    const checked = favouritesStore.favouritesData.some((item) => Number(item.id) === Number(product.id));
    const favoriteChange = (event: ChangeEvent<HTMLInputElement>) => favouritesStore.favouritesChange(event, product);

    return {
        checked,
        favoriteChange
    }
}
